

import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiTarget,
  FiCheckCircle,
  FiZap,
  FiTool,
  FiShield,
  FiTruck,
  FiFlag,
  FiAward,
  FiUsers,
  FiTrendingUp,
  FiArrowRight,
  FiPhoneCall,
  FiLinkedin,
  FiEye,

} from 'react-icons/fi';

import princeImg from '../assest/team/prince-kumar.png';
import rishitImg from '../assest/team/rishit-sengar.png';
import raghurajImg from '../assest/team/raghuraj-singh.png';
import Reveal from '../common/Reveal';
import Counter from '../common/Counter';

import heroImg from '../assest/about us.png';
import img2009 from '../assest/journey-2009.avif';
import img2018 from '../assest/journey-2018.jpg';
import img2022 from '../assest/journey-2022.jpg';
import visionImg from '../assest/manufacturing/sections/vm_vision.png';
import missionImg from '../assest/manufacturing/sections/vm_mission.png';

 //client logo
  import bvnl from '../assest/client logo/BVNL cli.jpg';
import ndpdcl  from '../assest/client logo/ndpdcl clie.png';
import NTPC  from '../assest/client logo/NTPC CL.jpg';
import JVVNL from '../assest/client logo/NHAI CLI.jpg';


import transformerImg from '../assest/transformer/transformer_1.jpg'; // TODO: add your transformer product image with this exact filename
import pSteelPole from '../assest/NEW RA.png';
import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';
import pACSR from '../assest/product image transparent/01_ACSR_Conductors.png.png';
import pLA from '../assest/product image transparent/11kV_Polymeric_Type_Lightning_Arrester.png.png';
import pCable from '../assest/product image transparent/MV_XLPE_Insulated_Armoured_Cable.png.png'; // TODO: add a cables product image with this exact filename
import pInsulator from '../assest/product image transparent/33kV_Polymer_Pin_Insulator_10kN_Strength.png.png'; // TODO: add an insulators product image with this exact filename

const team = [
  {
    name: 'Mr. Prince Kumar',
    role: 'Managing Director',
    photo: princeImg,
    bio: '13+ years across electrical manufacturing & trading projects since 2009, serving clients like L&T Construction, Shapoorji Pallonji, Indian Oil and Jaguar Overseas.',
  },
  {
    name: 'Mr. Rishit Sengar',
    role: 'Director',
    photo: rishitImg,
    bio: 'Electrical engineering graduate (RGPV, 2013) with 6+ years in power distribution — FSP Betul, RGGVY Hoshangabad & Sehore, DDUGJY Betul, HVDS Nandurbar.',
  },
  {
    name: 'Mr. Raghuraj Singh',
    role: 'Advisor',
    photo: raghurajImg,
    bio: 'B.E. Electrical with 25+ years across industry and infra — RGGVY, ADB, RAPDRP and DDUGJY projects as DGM and GM.',
  },
];

const services = [
  {
    icon: FiTool,
    title: 'Transformer Manufacturing',
    tag: 'Core Manufacturing',
    desc: 'We manufacture Distribution Transformers (DTR) entirely in-house, from raw core & winding stage to final testing — giving us complete control over quality at every step.',
    points: [
      'Capacity range from 25 kVA up to 20000 kVA',
      'Oil-cooled design built to relevant BIS standards',
      'Every unit tested for insulation, efficiency & load before dispatch',
    ],
    img: transformerImg,
  },
  {
    icon: FiZap,
    title: 'All Types of Electric Poles',
    tag: 'Core Manufacturing',
    desc: 'Our in-house fabrication unit produces PSC, Rail, Tubular, Octagonal and RSJ poles used across HT/LT power distribution lines — built to exact client and utility specifications.',
    points: [
      'PSC Pole',
      'Rail Pole',
      'Tubular Pole',
      'Octagonal Pole',
      'RSJ Pole',
    ],
    img: pSteelPole,
  },
  {
    icon: FiShield,
    title: 'Control & Distribution Panels',
    tag: 'Core Manufacturing',
    desc: 'We design and manufacture control panels and distribution boards used across substations, industrial units and utility installations.',
    points: [
      'Built with quality-checked electrical components',
      'Tested for safety, load handling & performance',
      'Custom configurations available as per project need',
    ],
    img: pControlPanel,
  },
  {
    icon: FiTruck,
    title: 'Trading & Supply',
    tag: 'Trading Basis',
    desc: 'Beyond manufacturing, we also source and supply a wider range of electrical goods & components across the full 33 kV range on a trading basis — so clients get everything under one roof.',
    tradingItems: [
      { name: 'ACSR Conductors', img: pACSR },
      { name: 'Lightning Arresters', img: pLA },
      { name: 'Cables', img: pCable },
      { name: 'Insulators', img: pInsulator },
    ],
  },
];


const clientLogos = [
  { name: 'BVNL', logo: bvnl },
  { name: 'NDPDCL', logo: ndpdcl },
  { name: 'NTPC', logo: NTPC },
  { name: 'JVVNL', logo: JVVNL },
];

// Milestones — enriched with facts pulled straight from the Prithviraj company catalogue
const milestones = [
  {
    year: '2009',
    icon: FiFlag,
    title: 'Groundwork begins',
    desc: 'Our founder starts out on electrical manufacturing projects — years of hands-on technical experience that would later become the foundation of Prithviraj Corporation Limited.',
    img: img2009,
  },
  {
    year: 'Mar 2018',
    icon: FiAward,
    title: 'Prithviraj Corporation Ltd. founded',
    desc: 'Established by Mr. Prince Kumar & Mrs. Priti Kumar as parent directors, with a registered workshop at Barauni, Begusarai, Bihar and a corporate office in Gurugram, Haryana — built from day one as an ISO 9001:2015 Certified  company.',
    img: img2018,
  },
  {
    year: 'Aug 2022',
    icon: FiUsers,
    title: 'Leadership strengthened',
    desc: 'Mr. Rishit Sengar joins as Director, bringing 6+ years of power distribution experience to strengthen the skilled workforce and help the company achieve new benchmarks.',
    img: img2022,
  },
  {
    year: 'Today',
    icon: FiTrendingUp,
    title: '17+ years of combined expertise',
    desc: 'A government approved manufacturer & trader, manufacturing transformers, steel structures and control panels in-house, while trading electrical components across the full 33 kV range for clients across multiple states.',
    img: null, // TODO: client image pending
  },
];

// Animated center line for the "Our Journey" timeline — grows downward the
// first time it scrolls into view (same IntersectionObserver pattern as Reveal).
function GrowLine() {
  const ref = React.useRef(null);
  const [grown, setGrown] = React.useState(false);

  React.useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setGrown(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`pointer-events-none absolute inset-y-0 left-1/2 hidden w-px origin-top -translate-x-1/2 bg-gradient-to-b from-brand-orange via-brand-orange/40 to-transparent transition-transform duration-[1800ms] ease-out lg:block ${
        grown ? 'scale-y-100' : 'scale-y-0'
      }`}
    />
  );
}

export default function About() {
  return (
    <div className="overflow-x-hidden">
      {/* ---------------- HERO (darkened/blurred image with heading) ---------------- */}
 <section className="relative h-screen w-full overflow-hidden">
  <img
    src={heroImg}
    alt="Prithviraj Corporation Limited"
    className="absolute inset-0 h-full w-full object-cover"
  />

  {/* text overlay content */}
  <div className="absolute inset-0 flex items-center">
    <div className="mx-auto w-full max-w-7xl px-6 sm:px-10 lg:px-14">
      <div className="max-w-md lg:max-w-lg">
        {/* heading */}
        <h1 className="mt-6 text-5xl font-extrabold uppercase leading-none sm:text-6xl lg:text-7xl hero-shimmer block text-brand-orange">
          About Us
        </h1>
        <span className="mt-4 block h-1 w-16 rounded-full bg-brand-orange" />

        <h2 className="mt-4 text-xl font-bold leading-snug text-white sm:text-2xl">
          Building a Stronger,{' '}
          <span className="text-brand-orange">Electrified</span> Tomorrow
        </h2>

        <p className="mt-4 max-w-md text-sm leading-relaxed text-white/80 sm:text-base">
          Prithviraj Corporation Limited is a trusted manufacturer, supplier and
          solution provider of a wide range of electrical transmission and
          distribution products. We are committed to delivering quality,
          reliability and value through every product and solution we offer.
        </p>
      </div>
    </div>
  </div>
</section>
{/* ---------------- CLIENTS (logo marquee) ---------------- */}
      {/* ---------------- OUR TRUSTED CLIENTS ---------------- */}
      <section className="bg-white py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-3xl text-center">
            <h2 className="text-5xl font-extrabold uppercase tracking-wide hero-shimmer block text-brand-orange">
              Our Trusted Clients
            </h2>
            <h3 className="mt-4 text-3xl font-bold text-slate-900">
              Proudly Serving India&rsquo;s Leading Government Organizations &amp; Infrastructure Companies
            </h3>
            <p className="mx-auto mt-5 max-w-[700px] text-base leading-relaxed text-slate-600 sm:text-lg">
              We are proud to be associated with leading government organizations, public
              sector undertakings, and infrastructure companies. Our commitment to quality,
              reliability, and timely delivery has earned the trust of clients across the
              power transmission and distribution industry.
            </p>
          </Reveal>

          {/* logo grid */}
          <div className="mt-16 grid grid-cols-2 gap-8 lg:grid-cols-4">
            {clientLogos.map((client, i) => (
              <Reveal key={client.name} delay={i * 100}>
                <div className="group flex h-[140px] items-center justify-center rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-300 ease-out hover:-translate-y-2 hover:shadow-xl">
  <img
    src={client.logo}
    alt={client.name}
    className="h-full max-h-[110px] w-full object-contain transition-transform duration-300 ease-out group-hover:scale-105"
    loading="lazy"
  />
</div>
              </Reveal>
            ))}
          </div>

          {/* feature badges */}
          <Reveal delay={250}>
            <div className="mt-16 grid grid-cols-2 gap-5 sm:grid-cols-4">
              {[
                { icon: FiAward, label: '17+ Years Experience' },
                { icon: FiUsers, label: 'Trusted by Government Organizations' },
                { icon: FiTool, label: 'Quality Manufacturing' },
                { icon: FiTruck, label: 'PAN India Supply' },
              ].map((f) => {
                const Icon = f.icon;
                return (
                  <div
                    key={f.label}
                    className="flex flex-col items-center gap-3 rounded-2xl border border-slate-100 bg-slate-50/60 px-4 py-6 text-center transition-colors duration-300 hover:bg-brand-orange/5"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange">
                      <Icon size={22} />
                    </span>
                    <span className="text-xs font-semibold uppercase tracking-wide text-slate-700 sm:text-sm">
                      {f.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---------------- OUR JOURNEY (zigzag, image + scroll-reveal) ---------------- */}

      {/* ---------------- TEAM (rectangular portrait style) ---------------- */}

      {/* ---------------- OUR JOURNEY (zigzag, image + scroll-reveal) ---------------- */}
      <section className="relative bg-slate-50 py-16 sm:py-20 overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-orange/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-3xl text-center">
            <h2 className="break-words text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                OUR JOURNEY
              </span>
            </h2>
            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              17+ Years, One Milestone at a Time
            </h3>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
              From a founder&rsquo;s first hands-on projects in 2009 to a government approved
              manufacturer & trader serving clients across multiple states — here&rsquo;s how Prithviraj
              Corporation Limited got here, one milestone at a time.
            </p>
          </Reveal>

          <div className="relative mt-14 space-y-14 sm:space-y-20">
            {/* animated center line — grows in on scroll, larger screens only */}
            <GrowLine />

            {milestones.map((m, i) => {
              const reverse = i % 2 === 1;
              const Icon = m.icon;
              return (
                <Reveal key={m.year} direction={reverse ? 'left' : 'right'} delay={i * 100}>
                  <div
                    className={`relative grid items-center gap-6 lg:grid-cols-2 lg:gap-14 ${
                      reverse ? 'lg:[&>*:first-child]:order-2' : ''
                    }`}
                  >
                    {/* text card */}
                    <div className="group relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1.5 hover:shadow-xl sm:p-8">
                      {/* faint giant background icon, grows subtly on hover */}
                      <Icon
                        aria-hidden="true"
                        className="pointer-events-none absolute -right-5 -top-5 text-brand-orange/[0.07] transition-transform duration-700 ease-out group-hover:scale-110 group-hover:rotate-6"
                        size={120}
                      />

                      <div className="relative flex items-center gap-3">
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange transition-all duration-300 group-hover:scale-110 group-hover:bg-brand-orange group-hover:text-white">
                          <Icon size={19} />
                        </span>
                        <span className="inline-flex items-center gap-2 rounded-full bg-brand-orange/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand-orange">
                          {m.year}
                        </span>
                      </div>

                      <h3 className="relative mt-4 text-xl font-extrabold text-navy">{m.title}</h3>
                      <p className="relative mt-2 text-sm leading-relaxed text-slate-600">{m.desc}</p>

                      {/* bottom accent line grows on hover */}
                      <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-brand-orange transition-all duration-500 group-hover:w-full" />
                    </div>

                    {/* image */}
                    <div className="group relative h-56 overflow-hidden rounded-3xl shadow-sm sm:h-72 lg:h-80">
                      {m.img ? (
                        <img
                          src={m.img}
                          alt={m.title}
                          className="h-full w-full object-cover transition duration-500 group-hover:scale-110"
                        />
                      ) : (
                        <div className="flex h-full w-full items-center justify-center bg-navy">
                          <span className="text-xs font-semibold uppercase tracking-wide text-white/40">
                            Image coming soon
                          </span>
                        </div>
                      )}
                      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/30 via-transparent to-transparent" />
                    </div>

                    {/* dot on the center line, with a soft pulsing ring behind it */}
                    <span className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 lg:flex lg:items-center lg:justify-center">
                      <span className="absolute h-5 w-5 animate-ping rounded-full bg-brand-orange/50" />
                      <span className="relative h-4 w-4 rounded-full border-4 border-slate-50 bg-brand-orange shadow" />
                    </span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
      {/* ---------------- STORY (split layout + pull-quote) ---------------- */}
      <section className="mx-auto max-w-7xl px-4 pb-24 pt-16 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal direction="right">
            <span className="inline-block rounded-full bg-brand-orange/10 px-4 py-1 text-xs font-bold uppercase tracking-wide text-brand-orange">
              Our Story
            </span>
            <h2 className="mt-3 text-2xl font-extrabold text-navy sm:text-3xl">
              Providing services beyond the ordinary
            </h2>

            <blockquote className="mt-6 border-l-4 border-brand-orange bg-brand-orange/5 py-3 pl-5 pr-4">
              <p className="text-lg font-semibold italic leading-snug text-navy">
                “From tendering to execution, we track every stage of a project —
                planning, procurement and implementation.”
              </p>
            </blockquote>

            <p className="mt-5 text-slate-600">
              We take pride in introducing ourselves as a leading government approved contractor for
              electrical manufacturing and trading, delivering consistent, reliable
              results at every step.
            </p>
           <p className="mt-4 text-slate-600">
  Our core strength lies in <span className="font-semibold text-navy">in-house manufacturing of
  transformers, electric poles and control &amp; distribution panels</span> — built and
  quality-checked entirely under our own roof. Beyond this, we also trade a wider range of
  electrical goods and components for the power distribution field, ensuring our clients get
  everything they need under one roof.
</p>
          </Reveal>

          <Reveal direction="left" delay={150}>
            <div className="relative">
              <div className="pointer-events-none absolute -right-4 -top-4 h-full w-full rounded-3xl border-2 border-brand-orange/20 lg:-right-6 lg:-top-6" />
              <div className="relative h-72 overflow-hidden rounded-3xl shadow-lg sm:h-96 lg:h-[420px]">
                <img
                  src={img2018}
                  alt="Prithviraj Corporation team at work"
                  className="h-full w-full object-cover"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/40 via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-6 left-1/2 flex w-[85%] -translate-x-1/2 items-center justify-between rounded-2xl bg-navy px-6 py-4 shadow-xl">
                <div>
                  <p className="text-2xl font-extrabold text-white">
                    <Counter value={17} suffix="+" />
                  </p>
                  <p className="text-xs font-medium uppercase tracking-wide text-white/60">Years of Trust</p>
                </div>
                <div className="h-8 w-px bg-white/20" />
                <div>
                  <p className="text-2xl font-extrabold text-white">
                    <Counter value={7} suffix="+" />
                  </p>
                  <p className="text-xs font-medium uppercase tracking-wide text-white/60">Major Clients</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---------------- SERVICES (detailed rows: text + image) ---------------- */}
  <section className="py-16 sm:py-20 overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mx-auto max-w-3xl text-center">
        {/* Main Heading */}
        <h2 className="break-words text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
          <span className="hero-shimmer block text-brand-orange">
            AT A GLANCE
          </span>
        </h2>
  
        {/* Secondary Heading */}
        <h3 className="mt-4 break-words text-xl font-bold leading-tight text-navy sm:text-2xl lg:text-3xl">
          What We Do, End to End
        </h3>
  
        {/* Description */}
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
          Manufacturing kept in-house, quality kept in our hands — supported by
          trading & supply for everything else our clients need.
        </p>
      </Reveal>
  
      <div className="mt-14 grid gap-6 sm:grid-cols-2">
        {services.map((s, i) => {
          const Icon = s.icon;
          const isTrading = s.tag === 'Trading Basis';
          return (
            <Reveal key={s.title} delay={i * 80}>
              {/* ---- outer wrapper: subtle static gradient border (no spin) ---- */}
              <div className="group relative h-full overflow-hidden rounded-3xl p-[1.5px] bg-gradient-to-br from-brand-orange/25 via-white/5 to-transparent">
                {/* ---- actual card: flat solid dark navy background ---- */}
                <div
                  className="relative z-10 flex h-full flex-col rounded-3xl bg-[#0B0F1F] p-6 shadow-[inset_0_-16px_24px_0_rgba(255,255,255,0.03)] transition-transform duration-300 ease-out sm:p-7"
                >
                  {/* Icon + Tag */}
                  <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
                      <Icon size={20} />
                    </span>
                    <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-brand-orange">
                      {s.tag}
                    </span>
                  </div>
  
                  {/* Title */}
                  <h2 className="mt-4 text-xl font-extrabold text-white sm:text-2xl">
                    {s.title}
                  </h2>
  
                  {/* Description */}
                  <p className="mt-2 text-sm leading-relaxed text-white/70">
                    {s.desc}
                  </p>
  
                  <span className="mt-4 block h-[1px] w-full bg-white/10" />
  
                  {/* Content row: points + image tile(s) */}
                  <div className="mt-4 flex flex-1 items-start gap-5">
                    {s.points && (
                      <ul className="flex-1 space-y-2.5">
                        {s.points.map((pt) => (
                          <li key={pt} className="flex items-start gap-2">
                            <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={15} />
                            <span className="text-xs leading-relaxed text-white/80 sm:text-sm">{pt}</span>
                          </li>
                        ))}
                      </ul>
                    )}
  
                    {isTrading ? (
                      <div className="grid shrink-0 grid-cols-2 gap-2.5">
                        {s.tradingItems.map((item) => (
                          <div
                            key={item.name}
                            className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white p-2.5 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-20 sm:w-20"
                            title={item.name}
                          >
                            <img
                              src={item.img}
                              alt={item.name}
                              className="h-full w-full object-contain"
                              loading="lazy"
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex h-28 w-28 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white p-4 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-32 sm:w-32">
                        <img
                          src={s.img}
                          alt={s.title}
                          className="h-full w-full object-contain"
                          loading="lazy"
                        />
                      </div>
                    )}
                  </div>
  
                  {/* Button — same gradient pill style as contact form submit */}
                  <Link
                    to="/products"
                    className="group/btn mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-t from-brand-orangedark to-brand-orange px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-[inset_0_-2px_25px_-4px_rgba(255,255,255,0.4)] transition hover:-translate-y-0.5"
                  >
                    View Details
                    <FiArrowRight className="transition group-hover/btn:translate-x-1" size={15} />
                  </Link>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>

     

      {/* ---------------- MISSION / VISION ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
             <div className="space-y-14">
               <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
                 <Reveal direction="right">
                   <div className="flex items-center gap-4">
                     <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy text-white">
                       <FiEye size={24} />
                     </span>
                     <h2 className="text-2xl font-extrabold uppercase tracking-tight text-navy sm:text-3xl">
                       Our <span className="block">Vision</span>
                     </h2>
                   </div>
                   <span className="mt-3 block h-1 w-14 rounded-full bg-brand-orange" />
                   <p className="mt-4 max-w-md text-slate-600">
                     To be a leading force in the power sector, delivering innovative, reliable and
                     sustainable solutions that empower communities and drive a brighter future.
                   </p>
                 </Reveal>
                 <Reveal direction="left" delay={120}>
                   <div className="overflow-hidden rounded-3xl shadow-sm">
                     <img src={visionImg} alt="Our Vision" className="h-64 w-full object-cover sm:h-80" loading="lazy" />
                   </div>
                 </Reveal>
               </div>
     
               <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
                 <Reveal direction="right" className="order-2 lg:order-1">
                   <div className="overflow-hidden rounded-3xl shadow-sm">
                     <img src={missionImg} alt="Our Mission" className="h-64 w-full object-cover sm:h-80" loading="lazy" />
                   </div>
                 </Reveal>
                 <Reveal direction="left" delay={120} className="order-1 lg:order-2">
                   <div className="flex items-center gap-4">
                     <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy text-white">
                       <FiTarget size={24} />
                     </span>
                     <h2 className="text-2xl font-extrabold uppercase tracking-tight text-navy sm:text-3xl">
                       Our <span className="block">Mission</span>
                     </h2>
                   </div>
                   <span className="mt-3 block h-1 w-14 rounded-full bg-brand-orange" />
                   <p className="mt-4 max-w-md text-slate-600">
                     To deliver high-quality products and services through innovation, skilled expertise,
                     and a commitment to safety and excellence. We aim to build lasting relationships by
                     exceeding customer expectations and contributing to the nation&rsquo;s power
                     infrastructure growth.
                   </p>
                 </Reveal>
               </div>
             </div>
           </section>

      {/* ---------------- TEAM (rectangular portrait style) ---------------- */}
   <section className="bg-white py-16">
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <Reveal className="mx-auto max-w-2xl text-center">
      <span className="inline-block rounded-full bg-brand-orange/10 px-4 py-1 text-xs font-bold uppercase tracking-wide text-brand-orange">
        Leadership
      </span>
      <h2 className="mt-3 text-2xl font-extrabold text-navy sm:text-3xl">The people behind Prithviraj</h2>
    </Reveal>

    <div className="mt-10 grid gap-6 sm:grid-cols-2 md:grid-cols-3 max-w-3xl mx-auto md:max-w-none">
      {team.map((member, i) => (
        <Reveal key={member.name} delay={i * 120}>
          <div className="group mx-auto h-full max-w-xs overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition duration-300 hover:-translate-y-2 hover:shadow-lg">
            <div className="relative h-60 w-full overflow-hidden bg-slate-100">
              <img
                src={member.photo}
                alt={member.name}
                className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/60 via-navy/0 to-transparent" />
              <span className="absolute bottom-3 left-3 inline-block rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-navy shadow">
                {member.role}
              </span>
            </div>

            <div className="p-4">
              <h3 className="flex items-center gap-2 text-sm font-bold text-navy">
                {member.name}
                <FiLinkedin className="text-slate-300 transition group-hover:text-brand-orange" size={14} />
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-600">{member.bio}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
</section>

      {/* ---------------- CTA ---------------- */}
      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center text-white sm:px-16">
          <h2 className="text-2xl font-extrabold sm:text-3xl">Want to work with us?</h2>
          <p className="mx-auto mt-3 max-w-xl text-white/70">
            Whether it&rsquo;s a manufacturing order, a bulk supply order, or a custom transformer — let&rsquo;s talk.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            >
              <FiPhoneCall /> Talk to Us
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
            >
              Explore Products <FiArrowRight />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}